// Reference: https://www.smashingmagazine.com/2020/03/sortable-tables-react/

import { useMemo, useState } from 'react'
import PokerSite from './PokerSite'

const useSortableData = (items = [], config = null) => {
    const [sortConfig, setSortConfig] = useState(config)

    const sortedItems = useMemo(() => {
      let sortableItems = [...items]
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          if(sortConfig.type === "float") {
            if (parseFloat(a[sortConfig.key]) < parseFloat(b[sortConfig.key])) {
              return sortConfig.direction === 'ascending' ? -1 : 1
            }
            if (parseFloat(a[sortConfig.key]) > parseFloat(b[sortConfig.key])) {
              return sortConfig.direction === 'ascending' ? 1 : -1
            }
          } else if(sortConfig.type === "string" || sortConfig.type === "date") {
            if (a[sortConfig.key] < b[sortConfig.key]) {
              return sortConfig.direction === 'ascending' ? -1 : 1
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
              return sortConfig.direction === 'ascending' ? 1 : -1
            }
          }
          return 0
        })
      }
      return sortableItems
    }, [items, sortConfig])

    const requestSort = (key, type) => {
      let direction = 'ascending'
      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === 'ascending'
      ) {
        direction = 'descending'
      }
      setSortConfig({ key, type, direction })
    }

    return { items: sortedItems, requestSort, sortConfig }
}

const TournamentsTable = (props) => {
    const { items, requestSort, sortConfig } = useSortableData(props.tournaments || [])

    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return
      }
      return sortConfig.key === name ? sortConfig.direction : undefined
    }

    return (
      <figure className="wp-block-table">
          <div className="table-responsive">
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th colSpan="2">Poker Site</th>
                        <th>
                        <button
                        type="button"
                        onClick={() => requestSort('date', 'date')}
                        className={getClassNamesFor('date')}
                        >
                        Aanvang
                        </button>
                        </th>
                        <th>
                        <button
                        type="button"
                        onClick={() => requestSort('name', 'string')}
                        className={getClassNamesFor('name')}
                        >
                        Naam
                        </button>
                        </th>
                        <th>
                        <button
                        type="button"
                        onClick={() => requestSort('buy_in', 'float')}
                        className={getClassNamesFor('buy_in')}
                        >
                        Buy-In
                        </button>
                        </th>
                        <th>
                        <button
                        type="button"
                        onClick={() => requestSort('fee', 'float')}
                        className={getClassNamesFor('fee')}
                        >
                        Fee
                        </button>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {items.map((data, key) => {
                      const pokerSite = props.pokerSites[data.online_poker_site]
                      if(pokerSite !== undefined) {
                        return (
                          <tr key={key}>
                              <td><PokerSite pokerSite={pokerSite}/></td>
                              <td>
                                <a className="d-block" href="https://www.pokerkamers.nl/go/bet365-poker/" rel="nofollow noreferrer noopener" target="_blank"><span className="d-none d-md-inline">Bezoek de Bet365 website</span><span className="d-md-none text-nowrap">Website &gt;</span></a>
                                <a className="d-block mt-2" href="https://www.pokerkamers.nl/pokersites/bet365-poker/"><span className="d-none d-md-inline">Lees onze Bet365 review</span><span className="d-md-none text-nowrap">Review &gt;</span></a>
                              </td>
                              <td>{data.date}</td>
                              <td>{data.name}</td>
                              <td>
                                {new Intl.NumberFormat("nl-NL", {
                                style: "currency",
                                currency: data.currency,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }).format(data.buy_in)}
                              </td>
                              <td>
                                {new Intl.NumberFormat("nl-NL", {
                                style: "currency",
                                currency: data.currency,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                              }).format(data.fee)}
                              </td>
                          </tr>
                        )
                      } else {
                        return null
                      }
                    })}
                </tbody>
            </table>
          </div>
      </figure>
    )
}

export default TournamentsTable